/*
 * @Description: 
 * @Author: zhaoshuai
 * @Date: 2021-03-02 10:14:32
 * @LastEditTime: 2021-03-30 09:35:09
 * @LastEditors: zhaoshuai
 */
import Vue from 'vue'
import Vuex from 'vuex'
import account from './modules/account'
import apply from './modules/apply'
import wx from './modules/wx'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        account,
        apply,
        wx
    }
})